import { Box } from "@mui/material";
import { SpecTable } from "./SpecTable";
import { SpecInputs } from "./SpecInputs";

export function SpecTab() {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", p: 1, gap: 2 }}>
      <Box>
        <SpecTable />
      </Box>
    </Box>
  );
}
